import { useCallback, useEffect, useState } from 'react';
import type { Category } from '@voice/shared';
import { supabase } from '../services/supabase';
import { useAuth } from './AuthContext';

export interface UseCategoriesReturn {
  categories: Category[];
  loading: boolean;
  refresh: () => Promise<void>;
}

export function useCategories(): UseCategoriesReturn {
  const { user } = useAuth();
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  const userId = user?.id;

  const fetch = useCallback(async () => {
    if (!userId) return;
    try {
      const { data, error } = await supabase
        .from('categories')
        .select('*')
        .eq('user_id', userId)
        .order('name', { ascending: true });

      if (error) throw error;
      setCategories((data ?? []) as Category[]);
    } catch {
      // non-fatal
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }
    fetch();
  }, [userId, fetch]);

  return { categories, loading, refresh: fetch };
}
